import { Buttons, FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const ModalContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 99;
  background: ${({ theme: { colors } }) => colors.darken};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled(FlexContainer)`
  position: relative;
  background-color: ${({ theme: { colors } }) => colors.white};
  border-radius: ${({ theme: { reference } }) => reference.dimension_16};
  min-width: 308px;
  min-height: 300px;
  justify-content: center;
  padding: ${({ theme: { sizing } }) => `${sizing.fds_size_32} ${sizing.fds_size_40}`};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    min-width: 90%;
    max-width: 90%;
  }
`;

export const CloseButton = styled(Buttons.Icon)`
  cursor: pointer;
  position: absolute;
  right: ${({ theme: { reference } }) => reference.dimension_16};
  top: ${({ theme: { reference } }) => reference.dimension_16};
  svg {
    width: ${({ theme: { sizing } }) => sizing.fds_size_16};
    height: ${({ theme: { sizing } }) => sizing.fds_size_16};
  }
`;

export const EfirmaContainer = styled(FlexContainer)`
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: auto;
  }
`;

export const SpinnerContainer = styled(FlexContainer)`
  height: 100%;
`;
